import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCrmOrgAlerts } from '../../../reducers/global/alertsReducers';
import { selectCrmOrgAssignments } from '../../../reducers/global/assignmentReducers';
import { selectCrmOrgAutomations } from '../../../reducers/global/automationReducers';
import {
  selectCrmOrgDedup,
  selectCrmOrgMatching,
} from '../../../reducers/global/dedupMatchingReducers';
import { selectCrmOrgScheduledAssignments } from '../../../reducers/global/scheduledAssignmentReducers';
import { getDeployedVersions } from './filters/utils';

export const useGetDeployedVersions = (crmOrgId: string) => {
  const sweepAutomations = useSelector(selectCrmOrgAutomations(crmOrgId));
  const sweepAlerts = useSelector(selectCrmOrgAlerts(crmOrgId));
  const sweepDedupe = useSelector(selectCrmOrgDedup(crmOrgId));
  const sweepMatching = useSelector(selectCrmOrgMatching(crmOrgId));
  const sweepAssignments = useSelector(selectCrmOrgAssignments(crmOrgId));
  const sweepScheduledAssignments = useSelector(selectCrmOrgScheduledAssignments(crmOrgId));

  // Memoize all deployed versions once to avoid multiple recalculations
  const deployedVersions = useMemo(
    () => ({
      automations: getDeployedVersions(sweepAutomations),
      alerts: getDeployedVersions(sweepAlerts),
      dedup: getDeployedVersions(sweepDedupe),
      matching: getDeployedVersions(sweepMatching),
      assignments: getDeployedVersions(sweepAssignments),
      scheduledAssignments: getDeployedVersions(sweepScheduledAssignments),
    }),
    [
      sweepAutomations,
      sweepAlerts,
      sweepDedupe,
      sweepMatching,
      sweepAssignments,
      sweepScheduledAssignments,
    ],
  );

  return deployedVersions;
};
